/* Campaign anchor IDs: resolve defaults, retain old fragments, and report editor conflicts. */
(function () {
  'use strict';
  if (window.sgBfAnchors) { window.sgBfAnchors.refresh(); return; }
  var mapping = new Map();
  function fragment(value) { try { return decodeURIComponent(value.replace(/^#/, '')); } catch (_) { return ''; } }
  function offset() {
    var bottom = 0;
    document.querySelectorAll('sticky-header,.shopify-section-header-sticky .header-wrapper,[data-sg-anchor-nav]').forEach(function (node) {
      var rect = node.getBoundingClientRect();
      if (rect.top <= 1 && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
    });
    var nav = document.querySelector('[data-sg-anchor-shell][data-sticky="true"] [data-sg-anchor-nav]');
    if (nav && !nav.classList.contains('is-pinned')) bottom += nav.getBoundingClientRect().height;
    return Math.max(140, bottom + 16);
  }
  function resolve(id) { return mapping.get(id) || document.getElementById(id); }
  function refresh(excluded) {
    document.querySelectorAll('[data-sg-anchor-alias],[data-sg-anchor-hint]').forEach(function (node) { node.remove(); });
    var roots = Array.from(document.querySelectorAll('[data-sg-anchor-default]')).filter(function (root) { return !excluded || !excluded.contains(root); });
    var rootSet = new Set(roots), occupied = new Set(), owners = new Map();
    document.querySelectorAll('[id]').forEach(function (node) { if (!rootSet.has(node) && (!excluded || !excluded.contains(node))) occupied.add(node.id); });
    roots.forEach(function (root) { if (!owners.has(root.dataset.sgAnchorDefault)) owners.set(root.dataset.sgAnchorDefault, root); });
    mapping = new Map();
    roots.forEach(function (root) {
      var requested = root.dataset.sgAnchorRequested, actual = requested, suffix = root.dataset.sgAnchorSection.replace(/[^a-zA-Z0-9-]/g, '-') || 'section';
      var count = 2;
      function unavailable(id) { return occupied.has(id) || (owners.has(id) && owners.get(id) !== root); }
      if (unavailable(actual)) actual = requested + '-' + suffix;
      while (unavailable(actual)) actual = requested + '-' + suffix + '-' + count++;
      root.id = actual; occupied.add(actual);
      root.style.scrollMarginTop = offset() + 'px';
      if (getComputedStyle(root).position === 'static') root.style.position = 'relative';
      if (root.hasAttribute('data-sg-anchor-editor')) {
        var hint = document.createElement('div'); hint.dataset.sgAnchorHint = '';
        hint.style.cssText = 'position:absolute;top:0;left:0;z-index:2;padding:6px 10px;max-width:100%;box-sizing:border-box;font:12px/1.4 monospace;background:#171611;color:#ffd277;border:1px solid #e6c68a;';
        hint.textContent = '锚点：#' + actual + (actual !== requested ? '（#' + requested + ' 冲突，已自动调整）' : '');
        root.prepend(hint);
      }
    });
    // Reserve legacy defaults before exposing custom names, so an old CTA never changes destination.
    roots.forEach(function (root) { if (!mapping.has(root.dataset.sgAnchorDefault)) mapping.set(root.dataset.sgAnchorDefault, root); });
    roots.forEach(function (root) { if (!mapping.has(root.id)) mapping.set(root.id, root); });
    roots.forEach(function (root) {
      var old = root.dataset.sgAnchorDefault;
      if (root.id !== old && !occupied.has(old) && mapping.get(old) === root) {
        var alias = document.createElement('span'); alias.id = old; alias.dataset.sgAnchorAlias = ''; alias.setAttribute('aria-hidden', 'true');
        alias.style.cssText = 'position:absolute;top:0;left:0;display:block;width:1px;height:1px;overflow:hidden;pointer-events:none;scroll-margin-top:' + offset() + 'px;';
        root.prepend(alias); occupied.add(old);
      }
    });
    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.dataset.sgAnchorOriginalHref || link.getAttribute('href');
      // Only literal same-document fragments are rewritten; external URLs remain untouched.
      if (!href || href.charAt(0) !== '#') return;
      var target = resolve(fragment(href)); if (!target) return;
      link.dataset.sgAnchorOriginalHref = href;
      link.setAttribute('href', '#' + target.id);
      if (link.hasAttribute('data-sg-anchor-link')) link.setAttribute('data-sg-anchor-link', target.id);
    });
    roots.forEach(function (root) { root.dispatchEvent(new CustomEvent('sg:anchor:updated', { bubbles: true })); });
    document.dispatchEvent(new CustomEvent('sg:anchors:updated'));
  }
  function jump() {
    var target = resolve(fragment(location.hash));
    if (target && target.hasAttribute('data-sg-anchor-default')) {
      window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset()), behavior: 'auto' });
    }
  }
  window.sgBfAnchors = { refresh: refresh, resolve: resolve };
  document.addEventListener('shopify:section:load', function () { refresh(); });
  document.addEventListener('shopify:section:unload', function (event) { refresh(event.target); });
  document.addEventListener('shopify:block:select', function () { refresh(); });
  window.addEventListener('hashchange', jump);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(); jump(); });
  else { refresh(); jump(); }
})();
